import { render, staticRenderFns } from "./DoctorAssistant.vue?vue&type=template&id=759f778a&scoped=true&"
import script from "./DoctorAssistant.vue?vue&type=script&lang=js&"
export * from "./DoctorAssistant.vue?vue&type=script&lang=js&"
import style0 from "./DoctorAssistant.vue?vue&type=style&index=0&id=759f778a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759f778a",
  null
  
)

export default component.exports